(function () {
    'use strict';

    angular
        .module('surveyControllers', ['services.esbEmployees',
                                      'ui.bootstrap.progressbar', ]);
})();
